<template>
    <div class="listView">
        <p class="itemTitle">{{ modalName }}</p>
        <ul>
            <li class="itemView" v-for="item in columns" @click="onConfirm(item)">
                <p class="tagView">{{ item.dataDictValue }}</p>
                {{item.remark}}
            </li>
        </ul>
        <img src="../../../assets/img/close.png" alt="" class="closeBtn" @click="onCancel">
    </div>
</template>

<script>
export default {
    name: 'chooseView',
    props: {
        columns: {type: Array, default: []},
        onCancel: {type: Function},
        onConfirm: {type: Function},
        modalName: {type: String},
    }
}
</script>

<style scoped>
.listView {
    background-color: white;
    padding: 0.2rem 0.2rem;
    border-radius: 0.12rem 0.12rem 0px 0px;
}

.itemView {
    font-size: 0.13rem;
    color: #5E5E66;
    padding: 0.17rem 0;
    border-bottom: 1px solid #EBEDF0;
    line-height: 0.21rem;
    display: flex;
    align-items: center;
}

.itemView:last-child {
    font-size: 0.13rem;
    color: #5E5E66;
    padding: 0.17rem 0;
    border-bottom: 0;
    line-height: 0.21rem;
    display: flex;
    align-items: center;
}

.itemTitle {
    text-align: center;
    font-weight: bold;
    font-size: 0.18rem;
}

.tagView {
    background-color: #FF571A;
    width: 0.36rem;
    height: 0.36rem;
    border-radius: 0.18rem;
    text-align: center;
    color: white;
    font-size: 0.16rem;
    font-weight: bold;
    line-height: 0.36rem;
    flex-shrink: 0;
    margin-right: 0.12rem;
}

.closeBtn {
    width: 0.24rem;
    position: absolute;
    top: 0.15rem;
    right: 0.2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/searchForm/components/chooseView.vue